import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { UserRetrieveResponse } from '@fireflyhealth/api'
import { Provider } from '~/entities/provider'
import keyBy from 'lodash/fp/keyBy'

import { patientsSlice } from '~/entities/person'
import { GET_PROVIDERS_SUCCESS } from '~/app/store/actions/actionTypes'

interface UsersState {
  // What RTK's removed `Dictionary` was: an id map whose misses are `undefined`.
  byId: Record<string, UserRetrieveResponse | Provider | undefined>
}

// A typed constant rather than `{ byId: {} } as UsersState`: the assertion was what gave the
// slice its declared state type, and every `state.users.byId` read depends on it.
const INITIAL_STATE: UsersState = { byId: {} }

const usersSlice = createSlice({
  name: 'users',
  initialState: INITIAL_STATE,
  reducers: {},
  // Builder callback rather than the object map, which RTK 2 removed.
  extraReducers: builder => {
    builder.addCase(
      patientsSlice.actions.getPatientSuccess,
      (state, { payload: patient }: PayloadAction<UserRetrieveResponse>) => {
        state.byId[patient.id] = patient
      },
    )
    // A hand-rolled action, so its shape is declared here rather than inferred:
    // the providers ride on the action itself, not on `payload`.
    builder.addCase(
      GET_PROVIDERS_SUCCESS,
      (state, action: { type: typeof GET_PROVIDERS_SUCCESS; providers: Provider[] }) => {
        state.byId = { ...state.byId, ...keyBy('id', action.providers) }
      },
    )
  },
})

export default usersSlice
